/*
 * As miniaturas de "Esquema de cores" (Configurações) desenhadas com o layout
 * do tema — cabeçalho com a busca no meio, barra lateral com "Iniciar Discussão" e
 * categorias, e o cartão com as abas e a lista — em vez da página do Flarum
 * padrão que o core desenha.
 *
 * Cada miniatura tem o próprio `data-theme`, então os tokens `--cn-*` dentro
 * dela já saem claros, escuros ou de alto contraste conforme o modo.
 */
import { override } from 'flarum/common/extend';
import ThemeMode from 'flarum/common/components/ThemeMode';
import classList from 'flarum/common/utils/classList';
/** Cores das categorias de mentira, só para dar vida à miniatura. */
const CATEGORY_COLORS = ['#0088cc', '#e45735', '#f1592a', '#3ab54a'];
function preview() {
  return m("div", {
    className: "ThemeMode-preview CanelaThemePreview"
  }, m("div", {
    className: "CanelaThemePreview-header"
  }, m("span", {
    className: "CanelaThemePreview-burger"
  }), m("span", {
    className: "CanelaThemePreview-logo"
  }), m("span", {
    className: "CanelaThemePreview-search"
  }), m("span", {
    className: "CanelaThemePreview-avatar"
  })), m("div", {
    className: "CanelaThemePreview-body"
  }, m("div", {
    className: "CanelaThemePreview-sidebar"
  }, m("span", {
    className: "CanelaThemePreview-newTopic"
  }), [0, 1, 2].map(i => m("span", {
    className: classList('CanelaThemePreview-link', {
      'CanelaThemePreview-link--active': i === 0
    }),
    key: `link${i}`
  }, m("i", null), m("b", null))), m("span", {
    className: "CanelaThemePreview-section"
  }), CATEGORY_COLORS.map((color, i) => m("span", {
    className: "CanelaThemePreview-link",
    key: `cat${i}`
  }, m("i", {
    style: {
      background: color,
      borderRadius: '1px'
    }
  }), m("b", null)))), m("div", {
    className: "CanelaThemePreview-main"
  }, m("div", {
    className: "CanelaThemePreview-card"
  }, m("div", {
    className: "CanelaThemePreview-nav"
  }, m("span", {
    className: "CanelaThemePreview-tab CanelaThemePreview-tab--active"
  }), m("span", {
    className: "CanelaThemePreview-tab"
  }), m("span", {
    className: "CanelaThemePreview-tab"
  }), m("span", {
    className: "CanelaThemePreview-button"
  })), [0, 1, 2, 3].map(i => m("div", {
    className: "CanelaThemePreview-row",
    key: `row${i}`
  }, m("span", {
    className: "CanelaThemePreview-title",
    style: {
      width: `${[70, 55, 62, 48][i]}%`
    }
  }), m("span", {
    className: "CanelaThemePreview-badge",
    style: {
      background: CATEGORY_COLORS[i]
    }
  }), m("span", {
    className: "CanelaThemePreview-count"
  })))))));
}
export default function installThemePreview() {
  override(ThemeMode.prototype, 'view', function (_original, vnode) {
    const {
      mode,
      selected,
      className,
      alternate,
      label,
      ...attrs
    } = vnode.attrs;
    return m("label", Object.assign({
      className: classList('ThemeMode', className, `ThemeMode--${mode}`, {
        'ThemeMode--active': selected,
        'ThemeMode--switch': alternate
      })
    }, attrs), m("div", {
      className: "ThemeMode-container",
      "data-theme": mode === 'auto' ? 'light' : mode,
      "data-colored-header": document.documentElement.getAttribute('data-colored-header')
    }, preview(), mode === 'auto' ? m(ThemeMode, Object.assign({
      mode: "dark",
      alternate: true,
      selected: selected
    }, attrs)) : null), !alternate ? m("div", {
      className: "ThemeMode-legend"
    }, label) : null);
  });
}
flarum.reg.add('ramon-canela', 'forum/shell/themePreview', installThemePreview);